import { render, staticRenderFns } from "./BoolQuestion.vue?vue&type=template&id=20cccde0&scoped=true&"
import script from "./BoolQuestion.vue?vue&type=script&lang=js&"
export * from "./BoolQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cccde0",
  null
  
)

export default component.exports